var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.4923V15.3608C4 15.7956 4.15804 16.2125 4.43934 16.5199C4.72064 16.8273 5.10218 17 5.5 17H14.5C14.8978 17 15.2794 16.8273 15.5607 16.5199C15.842 16.2125 16 15.7956 16 15.3608V12.4923M10.0006 12.2886L10.0006 3M10.0006 3L6.57199 6.54914M10.0006 3L13.4291 6.54914",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.27026c7d7c3cd422dcfd9dec6e70c4e0.svg";
export { ForwardRef as ReactComponent };